import * as types from "../../types/stores.types";

export const actionChangeStatusShowModalMyFoodPacks = (status_show_modal) => ({
    type: types.CHANGE_STATUS_SHOW_MODAL_MY_FOOD_PACKS, payload: {status_show_modal}
});

export const actionChangeLoaderFoodPacks = (loader_modal) => ({
    type: types.CHANGE_LOADER_MODAL_MY_FOOD_PACKS, loader_modal
});

export const actionSetMyFoodPacks = (food_packs) => ({
    type: types.PUT_SET_MY_FOOD_PACKS, food_packs
});